import { useRef, useEffect } from 'preact/hooks'

export default function useDebouncedEffect(handler, delay, args){
  const timeoutRef = useRef()
  useEffect(
    () => {
      const cancel = () => { clearTimeout(timeoutRef.current) }
      cancel()
      timeoutRef.current = setTimeout(handler, delay)
      return cancel
    },
    [delay, handler, ...args],
  )
}
